export default __webpack_public_path__ + "static/media/VG.08cc5c73.svg";